module.exports = __webpack_public_path__ + "img/tools_productivity_financial.4cbaecae.png";